var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolicon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.69055 28.9483C6.69055 18.4996 6.69055 13.273 9.93622 10.0273C13.1819 6.78162 18.4062 6.78162 28.8572 6.78162C39.3059 6.78162 44.5326 6.78162 47.7782 10.0273C51.0239 13.273 51.0239 18.4973 51.0239 28.9483C51.0239 39.397 51.0239 44.6236 47.7782 47.8693C44.5326 51.115 39.3082 51.115 28.8572 51.115C18.4086 51.115 13.1819 51.115 9.93622 47.8693C6.69055 44.6236 6.69055 39.3993 6.69055 28.9483Z",
    stroke: "#D7F266",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.8572 32.4482L18.3572 21.9482L22.7322 32.4482M14.8572 32.4482L13.6906 35.9482M14.8572 32.4482H22.7322M22.7322 32.4482L24.1906 35.9482M30.0239 28.9482V23.5816C30.0239 23.1476 30.0239 22.9282 30.0799 22.7532C30.1373 22.5783 30.2353 22.4195 30.3659 22.2897C30.4965 22.16 30.656 22.0629 30.8312 22.0066C31.0039 21.9482 31.2209 21.9482 31.6572 21.9482H34.6906C35.6188 21.9482 36.5091 22.317 37.1654 22.9734C37.8218 23.6297 38.1906 24.52 38.1906 25.4482C38.1906 26.3765 37.8218 27.2667 37.1654 27.9231C36.5091 28.5795 35.6188 28.9482 34.6906 28.9482H30.0239ZM30.0239 28.9482V35.9482M44.0239 21.9482V35.9482",
    stroke: "#D7F266",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolicon4);
export default __webpack_public_path__ + "static/media/toolicon4.66a7d5ca55a50cc53a4e76c63dcb9192.svg";
export { ForwardRef as ReactComponent };